var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-body"},[_c('Banner'),_c('HomeAbout'),_c('UniqueApproach'),_c('Worksite'),_c('ContactInfo')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }